export default __webpack_public_path__ + "static/media/appbar-mercury-logo.a4b8a25f.png";